import { useContext } from 'react';

import Modal from 'common/modal';
import {
  EstateResultItemState,
  EstateResultsPageContext,
} from 'pages/estate-results-page/context/estate-results-page-context';

import CreateOrEditResultItemForm from './create-or-edit-result-item-form';

type Props = {
  showModal: boolean;
  setShowModal: (value: boolean) => void;
  onExitClick: () => void;
  refetchResults?: () => void;
};

export default function AddOrEditResultItemModal({
  showModal,
  setShowModal,
  onExitClick,
  refetchResults,
}: Props) {
  const { setContext } = useContext(EstateResultsPageContext);

  const onExitClickWithCleanup = () => {
    const newContextValues: EstateResultItemState = {
      isEditingEstateResultItem: false,
      estateResultItemIdToEdit: null,
      setContext: setContext,
    };
    setContext(newContextValues);
    onExitClick();
  };

  return (
    <Modal
      setShowModal={setShowModal}
      onExitClick={onExitClickWithCleanup}
      showModal={showModal}
      showActions={false}
      content={
        <CreateOrEditResultItemForm
          onExitClick={onExitClickWithCleanup}
          refetchResults={refetchResults}
        />
      }
      loading={false}
      actionDisabled={false}
      maxWidth="sm"
    />
  );
}
